module.exports = __webpack_public_path__ + "img/HU.bc81bec9.svg";